<script setup>
import { useDisplay } from "vuetify";

definePage({
  name: "BaseMobileLoadout",
  path: "/base/mobile-loadout",
  meta: {
    layout: "default",
    requiresAuth: true,
    title: "Loadout",
    description: "Customize your mech loadout and profile on Nexus.",
  },
});

const authStore = useAuthStore();
const router = useRouter();
const { mobile } = useDisplay();

onMounted(() => {
  if (!mobile.value) {
    router.replace("/base");
  }
});
</script>

<template>
  <!-- StarrySky as fixed background -->
  <StarrySky class="" />

  <!-- Main Content -->
  <div class="tw-page-container tw-min-h-screen tw-relative tw-z-10">
    <v-container>
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-[9fr_11fr] tw-gap-4"
      >
        <div class="">
          <my-profile-block />
          <v-divider
            color="#D9D9D9"
            thickness="2"
            length="80%"
            opacity="1"
            class="tw-mx-auto tw-my-4"
          />
          <loadout-block />
        </div>
      </div>
    </v-container>
  </div>
</template>

<style></style>
